import { render } from "./sapSyncTask.vue?vue&type=template&id=1a2dc3fa&scoped=true"
import script from "./sapSyncTask.vue?vue&type=script&lang=js"
export * from "./sapSyncTask.vue?vue&type=script&lang=js"

import "./sapSyncTask.vue?vue&type=style&index=0&id=1a2dc3fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2dc3fa"]])

export default __exports__